import {mapGetters} from 'vuex';

export default {
    mounted(){
        window.addEventListener('resize', ()=>{
            this.windowWidth = window.innerWidth;
        });
    },

    data(){
        return {
            windowWidth: window.innerWidth
        }
    },

    computed:{
        scaledStyles(){
            return {
                //...this.projectDimensions,
                transform: `scale(${this.scale})`,
                transformOrigin: 'top left'
            }
        },

        scale(){
            return this.windowWidth / window.data.project.base_width;
        }
    },

    methods:{
        scaleValue(val){
            return val * this.scale;
        }
    }
}